module.exports = __webpack_public_path__ + "static/assets/a74d1aa27a14b866afe361c37420eb80.svg";